module.exports = require("./fr-GP.d.ts");